import { render } from "./UnidadMedida.vue?vue&type=template&id=5eeddc45&scoped=true"
import script from "./UnidadMedida.vue?vue&type=script&lang=js"
export * from "./UnidadMedida.vue?vue&type=script&lang=js"

import "./UnidadMedida.vue?vue&type=style&index=0&id=5eeddc45&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5eeddc45"]])

export default __exports__